module.exports = __webpack_public_path__ + "static/FoundersGroteskMonoTest-Regular-39e4b6da335481ba10dce5d49e47d004.eot";